import { motion } from "framer-motion";

const EVENTS = [
  {
    title: "Birthdays",
    img: "https://images.unsplash.com/photo-1758870041148-31d28fdf34d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwYXN0ZWwlMjBiYWxsb29uJTIwZ2FybGFuZCUyMGx1eHVyeXxlbnwwfHx8fDE3ODM1NTY1MTN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Illuminated birthday number with pastel balloons",
    span: "md:col-span-7 md:row-span-2",
    arch: false,
  },
  {
    title: "Anniversaries",
    img: "https://images.unsplash.com/photo-1560145726-2ef8f8d77913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxyb21hbnRpYyUyMGJsdXNoJTIwZXZlbnQlMjBkZWNvciUyMHRhYmxlc2NhcGV8ZW58MHx8fHwxNzkxNDY3ODQxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Champagne flutes at an anniversary celebration",
    span: "md:col-span-5",
    arch: true,
  },
  {
    title: "Intimate Dinners",
    img: "https://images.unsplash.com/photo-1732495522010-e0db10e3a56c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxyb21hbnRpYyUyMGJsdXNoJTIwZXZlbnQlMjBkZWNvciUyMHRhYmxlc2NhcGV8ZW58MHx8fHwxNzkxNDY3ODQxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Long candle-lit dinner table with florals",
    span: "md:col-span-5",
    arch: false,
  },
  {
    title: "Luxury Picnics",
    img: "https://images.unsplash.com/photo-1602468690798-0820b3ec6ee7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxyb21hbnRpYyUyMGJsdXNoJTIwZXZlbnQlMjBkZWNvciUyMHRhYmxlc2NhcGV8ZW58MHx8fHwxNzkxNDY3ODQxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Styled picnic table with white florals",
    span: "md:col-span-7",
    arch: false,
  },
];

export default function Events() {
  return (
    <section id="events" data-testid="events-section" className="py-28 lg:py-36 bg-[#F2D8D5]/20 border-y border-[#E5D3B3]/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-8 mb-16">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="eyebrow"
            >
              Affairs We Curate
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-6 font-serif font-light text-4xl sm:text-5xl leading-tight text-[#2A2423] max-w-xl"
            >
              Every occasion, dressed in its <em className="text-[#D8A7A1]">finest</em>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-sm leading-relaxed text-muted-foreground max-w-xs"
          >
            Birthdays, anniversaries, picnics, intimate dinners and everything worth celebrating in between.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[260px] gap-6" data-testid="events-gallery-grid">
          {EVENTS.map((e, i) => (
            <motion.figure
              key={e.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className={`group relative ${e.span}`}
              data-testid={`event-card-${e.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className={`overflow-hidden border border-[#E5D3B3] h-full ${e.arch ? "rounded-t-full" : ""}`}>
                <img
                  src={e.img}
                  alt={e.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute bottom-0 inset-x-0 p-5 bg-[#FDFBF7]/80 backdrop-blur-md border-t border-[#E5D3B3]/60 flex items-center justify-between translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-serif text-lg text-[#2A2423]">{e.title}</span>
                <span className="text-xs uppercase tracking-[0.2em] text-[#D8A7A1]">Enquire</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
